"use client";
import { FC, useEffect, useRef, useState } from "react";
import Image from "next/image";
import { cn } from "@/lib/utils";
import { solutionList } from "@/config/homeInfo";
import Link from "next/link";

export const Section4: FC = () => {
  const [isHoverIdx, setIsHoverIdx] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  /*   useEffect(() => {
    console.log(containerRef.current);
    if (!containerRef.current) return;
    containerRef.current.addEventListener("mouseenter", (e: MouseEvent) => {
      console.log(e);
      const idx = Number((e.target as HTMLDivElement).dataset.idx);
      console.log(idx);
      setIsHoverIdx(idx);
    });
  }, []); */

  return (
    <>
      <div className="container pt-10 pb-7 px-6  md:px-0 md:py-20">
        <h3 className="text-[#333333] text-lg  md:text-3xl text-center mb-5 md:mb-0">
          深入业务场景网络安全解决方案
        </h3>
        <h5 className="text-[#999999] text-base mt-5 mb-12 text-center hidden md:block">
          以零信任技术为基础，围绕5G、全连接、安全接入、SASE、安全服务运营等方向提供专业产品及解决方案
        </h5>

        <div
          className="flex flex-wrap  overflow-hidden sm:items-start sm:justify-between
            md:space-x-3 md:space-y-0 items-center space-y-3 sm:space-y-0"
        >
          {solutionList.map((item, idx) => (
            <div
              onMouseEnter={() => setIsHoverIdx(idx)}
              className={cn(
                "rounded p-7 md:px-9 md:py-10 flex-col flex items-start md:transition-all md:duration-[1500ms] ease-in-out",
                "bg-no-repeat w-full sm:w-[49%] h-36 md:w-48 md:h-96",
                isHoverIdx === idx && "h-72 md:w-96",
                "bg-cover bg-center",
                idx > 1 && "sm:!mt-3 md:!mt-0"
              )}
              style={{
                backgroundImage: `url('${
                  isHoverIdx === idx ? item.bgLarge : item.bgSmall
                }')`,
              }}
              data-idx={idx}
              key={idx}
            >
              <div className="h-[60%] space-y-[1.125rem]">
                <h5 className="text-base md:text-xl font-medium text-white">
                  {item.title}
                </h5>

                <p
                  className={cn(
                    "text-xs md:text-sm flex-1 text-white overflow-hidden text-ellipsis leading-[1.375rem] md:line-clamp-5",
                    isHoverIdx === idx ? "line-clamp-4" : "line-clamp-2"
                  )}
                >
                  {item.desc}
                </p>
              </div>

              <div
                className={cn(
                  "flex flex-1 flex-col justify-between md:transition-all md:delay-300  md:duration-1000 ease-in-out opacity-0",
                  isHoverIdx === idx && "opacity-100"
                )}
              >
                <div className="">
                  <p className="mb-2 md:mb-5 text-white text-base md:text-xl font-normal">
                    客户案例
                  </p>
                  <p className="flex flex-row">
                    {item.customerList.map((child, idx) => (
                      <Image
                        className="w-20 md:w-24 h-8 md:h-10 mr-2.5"
                        src={child.img}
                        alt={child.title}
                        width="100"
                        height="40"
                        key={idx}
                        quality={100}
                      />
                    ))}
                  </p>
                </div>
                <p className="text-white text-xs md:text-sm cursor-pointer underline">
                  查看详情
                  {/* <Link href={item.href}>查看详情</Link> */}
                </p>
              </div>
            </div>
          ))}
          {/* {Array.from({ length: 4 }, (_, idx) => (
            <div
              ref={itemRef}
              key={idx}
              data-idx={idx}
              className=" transition-all duration-[1500ms] ease-in-out w-48 h-96 pt-10 px-5 bg-neutral-700 rounded-lg flex flex-col items-start space-y-4"
            >
              <h5 className="text-xl font-medium text-white">零信任ZTNA</h5>
              <p className="text-base text-white overflow-hidden text-ellipsis line-clamp-3">
                环境感知、动态评估、身份认证
                统一控制、动态鉴权、态势感知企业多云统一管理，暴露面收敛资产东西向隔离防护，抵御各类网络攻
              </p>
            </div>
          ))} */}
        </div>
      </div>
    </>
  );
};
